window.PaymentDeclinedModal = null;
window.PaymentCrashedModal = null;
window.PaymentExpiredModal = null;


window.OpenModal = function (dialogElement) { 
    if (dialogElement && !dialogElement.open) {
        dialogElement.showModal();
    }
}

window.CloseModal = function (dialogElement) { 
     if (dialogElement && dialogElement.open) {
        dialogElement.close();
        dialogElement.remove();
    }
}

window.CloseBlazorModal = function(dialog) {
    if (dialog && dialog.open) {
        dialog.close();
        dialog.setAttribute('aria-hidden', 'true')
    }
}

window.CloseSwishModal = function () {
    let swishModal = document.getElementById("swish-modal");
    CloseBlazorModal(swishModal);
}

window.OpenPaymentDeclinedModal = function () {
    if (PaymentDeclinedModal == null) {
        $.ajax({
            url: "CheckoutModal/paymentDeclined",
            type: "GET",
            success: function (html) {
                PaymentDeclinedModal = $(html)[0];
                $("#js-modal").append(PaymentDeclinedModal);
                OpenModal(PaymentDeclinedModal);
            },
            error: function (xhr, status, error) {
                alert('Payment declined. Please try again or choose another payment method.');
            }
        })
    }
    else {

        $("#js-modal").append(PaymentDeclinedModal);
        OpenModal(PaymentDeclinedModal);
    }
}

window.OpenPaymentCrashedModal = function () {
    if (PaymentCrashedModal == null) {
        $.ajax({
            url: "CheckoutModal/paymentCrashed",
            type: "GET",
            success: function (html) {
                PaymentCrashedModal = $(html)[0];
                $("#js-modal").append(PaymentCrashedModal);
                OpenModal(PaymentCrashedModal);
            },
            error: function (xhr, status, error) {
                alert('Something went wrong during payment. Please try again or choose another payment method.');
            }
        })
    }
    else {
        $("#js-modal").append(PaymentCrashedModal);
        OpenModal(PaymentCrashedModal);
    }
}

window.OpenPaymentExpiredModal = function () {
    if (PaymentExpiredModal == null) {
        $.ajax({
            url: "CheckoutModal/paymentExpired",
            type: "GET",
            success: function (html) {
                PaymentExpiredModal = $(html)[0];
                $("#js-modal").append(PaymentExpiredModal);
                OpenModal(PaymentExpiredModal);
            },
            error: function (xhr, status, error) {
                alert('The payment was not completed on time. Please try again.');
            }
        })
    } else {
        $("#js-modal").append(PaymentExpiredModal);
        OpenModal(PaymentExpiredModal);
    }
}

